import { EffectCallback, useLayoutEffect } from 'react';

export default function useComponentDidMount(callback: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(callback, []);
}